import { Autocomplete, CircularProgress, TextField } from '@mui/material'
import React from 'react'
import { MapContext } from '../../../context/MapContext'
import { useCity } from '../../../context/CityContext'
import IconButton from '@mui/material/IconButton'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import Box from '@mui/material/Box'
import Dragsvg from '../../../assets/images/drag.svg'
import {Point} from '../../../__generated__/types';
import {useAddressSuggestionsQuery} from './__generated__/Address';
import { formatAddress } from '../../../utils/formatAddress';

export const AddressInput = ({
    point,
    title
}: {
    point: Point | null
    title: string
}) => {
    const { addPointByAddress, removePoint } =
        React.useContext(MapContext)
    const { selectedCity } = useCity()
    const [open, setOpen] = React.useState(false)
    const [options, setOptions] = React.useState<readonly Point[]>([])
    const [loading, setLoading] = React.useState<boolean>(false)

    const { refetch } = useAddressSuggestionsQuery({
        fetchPolicy: 'standby',
        variables: {
            input: null!,
            cityId: null
        }
    })
    // console.log(options)

    return (
        <div className='rout-section-from wf-section'>
            <div
                className={
                    title === 'Куда'
                        ? 'div-route-from-underline'
                        : 'div-route-from'
                }
            >
                {title ? (
                    <div className='route_text'>
                        <img
                            src={Dragsvg}
                            width={20}
                            height={20}
                            alt='dragsvg'
                            className='route_text_img'
                        />

                        {title}
                    </div>
                ) : null}
                <div style={{ display: 'flex' }}>
                    <Autocomplete
                        style={{ width: '90%' }}
                        id='standard-basic'
                        open={open}
                        value={point}
                        onInputChange={(_, value, reason) => {
                            if (reason === 'input' && value.length > 3) {
                                setOpen(true)
                                setLoading(true)
                                refetch({
                                    input: value,
                                    cityId: selectedCity?.id ?? null
                                })
                                    .then((res) => {
                                        setOptions(res.data?.searchAddress ?? [])
                                        setLoading(false)
                                    })
                                    .catch(() => setLoading(false))
                            }
                        }}
                        onClose={() => {
                            setOpen(false)
                        }}
                        onChange={(_, value) => {
                            value && addPointByAddress(value)
                        }}
                        // isOptionEqualToValue={(option, value) => option.title === value.title}
                        getOptionLabel={(option) =>
                            formatAddress(option, {
                                cityId: selectedCity?.id ?? null,
                                countryName: selectedCity?.countryName ?? null
                            })
                        }
                        filterOptions={(x) => x}
                        options={options}
                        loading={loading}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant='standard'
                                multiline
                                minRows={1}
                                maxRows={2}
                                InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true,
                                    style: {
                                        fontFamily: 'Inter',
                                        fontSize: '16px',
                                        lineHeight: '1',
                                        paddingRight: '0'
                                    },
                                    endAdornment: (
                                        <React.Fragment>
                                            {loading ? (
                                                <CircularProgress color='inherit' />
                                            ) : null}
                                            {/* {params.InputProps.endAdornment} */}
                                        </React.Fragment>
                                    )
                                }}
                            />
                        )}
                    />
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            aria-label='delete'
                            size='medium'
                            onClick={() => {
                                if (point) {
                                    removePoint(point)
                                }
                            }}
                        >
                            <HighlightOffIcon fontSize='inherit' />
                        </IconButton>
                    </Box>
                </div>
            </div>
        </div>
    )
}
